import React from "react";
import { Form, Input, theme } from "antd";
import { useResumeStore } from "../../store/resumeStore";
import { getInvalidSocialFields } from "./resumeValidation";

const { useToken } = theme;

export default function SocialEditor() {
  const { token } = useToken();
    const resume = useResumeStore((s) => s.resume);
    const updateResume = useResumeStore((s) => s.updateResume);
  const invalidSocialFields = getInvalidSocialFields(resume);
  const invalidLinkedIn = invalidSocialFields.includes("LinkedIn Profile URL");
  const invalidGitHub = invalidSocialFields.includes("GitHub Profile URL");

  // Theme-aware label style
  const labelStyle = {
    color: token.colorTextHeading,          // adapts to light/dark
    fontWeight: 500,
  };

  return (
    <>
      <h3 style={{ color: token.colorTextHeading, marginBottom: 16 }}>
        Social
      </h3>

      <Form layout="vertical">
        <Form.Item
          label={<span style={labelStyle}>LinkedIn Profile URL</span>}
          validateStatus={invalidLinkedIn ? "error" : undefined}
          help={
            invalidLinkedIn
              ? "Enter a valid LinkedIn profile URL, for example https://linkedin.com/in/username."
              : undefined
          }
        >
          <Input
            placeholder="https://linkedin.com/in/username"
            value={resume.linkedin}
            onChange={(e) => updateResume("linkedin", e.target.value)}
            spellCheck={false}
          />
        </Form.Item>

        <Form.Item
          label={<span style={labelStyle}>GitHub Profile URL</span>}
          validateStatus={invalidGitHub ? "error" : undefined}
          help={
            invalidGitHub
              ? "Enter a valid GitHub profile URL, for example https://github.com/username."
              : undefined
          }
        >
          <Input
            placeholder="https://github.com/username"
            value={resume.github}
            onChange={(e) => updateResume("github", e.target.value)}
            spellCheck={false}
          />
        </Form.Item>
      </Form>
    </>
  );
}
